// extracted by mini-css-extract-plugin
module.exports = {"text-bordered":"top-section_text-bordered__9Dugu"};